



































import ClientOnly from 'vue-client-only';
import { defineComponent, PropType } from '@vue/composition-api';
import { ProductBox } from '~/utils/types/Product';
import PLPProductBox from '../PLPProductBox.vue';
import CategoryPagination from './Pagination/CategoryPagination.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';

export default defineComponent({
    name: 'CategoryProductList',
    components: {
        PLPProductBox,
        ClientOnly,
        CategoryPagination,
        HTMLContent
    },
    props: {
        firstEditorialBox: {
            type: String
        },
        secondEditorialBox: {
            type: String
        },
        firstEditorialBoxPosition: {
            type: Number,
            default: 4
        },
        secondEditorialBoxPosition: {
            type: Number,
            default: 10
        },
        products: {
            type: Array as PropType<ProductBox[]>,
            required: true,
        },
        pagination: {
            type: Object,
            required: true
        },
        goToPage: {
            type: Function,
            required: true
        },
        trackCard: {
            type: Function
        },
        footerDescription: {
            type: String
        },
        categoryDescription: {
            type: String
        },
        pricesData: {
            type: Object as PropType<Record<string, any>>,
            default: () => ({})
        }
    },
    setup(props) {
        return {
            firstSlice: props.products.slice(0, props.firstEditorialBoxPosition - 1),
            secondSlice: props.products.slice(props.firstEditorialBoxPosition - 1, props.secondEditorialBoxPosition - 1),
            thirdSlice: props.products.slice(props.secondEditorialBoxPosition - 1, props.products.length),
            LAZY_LOADING_POSITION: 3
        }
    }
})
